// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable_cls1__ggwQJ","cls2":"VeloTable_cls2__f+K-8 VeloTable_cls1__ggwQJ"};